import Image from 'next/image'
import { GTM_CLICK_EVENT, useEventTracking } from '../../../../helpers/gtmHelper'
import { productTypeSelectorId } from '../constants'
import usePricingHero from './usePricingHero'

interface PricingHeroProps {
  isAITutorTab: boolean
}

const PricingHero = ({ isAITutorTab }: PricingHeroProps) => {
  const pricingHero = usePricingHero({ isAITutorTab })
  const { sendClickEvent } = useEventTracking()

  const scrollToProductTypeSelector = () => {
    const element = document.getElementById(productTypeSelectorId)
    if (element) {
      const offset = 60 // top bar height
      const top = element.getBoundingClientRect().top + window.pageYOffset - offset

      window.scrollTo({
        top,
        behavior: 'smooth',
      })
    }
  }

  const handleHeroImageClick = () => {
    sendClickEvent({ button_name: GTM_CLICK_EVENT.PURCHASE_HERO })
    scrollToProductTypeSelector()
  }

  if (!pricingHero) return null
  return (
    <div className="flex justify-center" style={{ backgroundColor: pricingHero.bgColor }}>
      <div className="w-full sm:max-w-[1180px] flex justify-center">
        {pricingHero.image && (
          <Image
            priority={true}
            src={pricingHero.image}
            width={1180}
            height={425}
            quality={100}
            alt="pricing_hero"
            onClick={handleHeroImageClick}
          />
        )}
      </div>
    </div>
  )
}

export default PricingHero
